const t = ["hours", "minutes", "seconds"], c = (e) => t.includes(e), o = (e, n) => n.getHours(e) * 3600 + n.getMinutes(e) * 60 + n.getSeconds(e), i = (e, n) => (r, s) => e ? n.isAfter(r, s) : o(r, n) > o(s, n);
export {
  i as createIsAfterIgnoreDatePart,
  o as getSecondsInDay,
  c as isTimeView
};
//# sourceMappingURL=time-utils.mjs.map
